function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import Button from './Button';
const AlgoliaClearRefinementsButton = /*#__PURE__*/React.memo(_ref => {
  let {
    items,
    refine,
    ...props
  } = _ref;
  const handleClick = () => refine(items);
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    onClick: handleClick,
    disabled: !items.length
  }));
});
AlgoliaClearRefinementsButton.propTypes = {};
AlgoliaClearRefinementsButton.defaultProps = {};
AlgoliaClearRefinementsButton.displayName = 'AlgoliaClearRefinementsButton';
export default connectCurrentRefinements(AlgoliaClearRefinementsButton);